module.exports = __webpack_public_path__ + "media/images/emblems/Sankt-Margreto-Blazono-a6a24ec7f5f627afa0cf9934895bd5c4.png";